import { Address } from '@rtls/core/models/location/address.model';
import { countryFactory } from '@rtls/core/models/location/country.factory';
import { chance, nullable } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';

export const addressFactory = Factory.makeFactory<Address>({
	id: Factory.each((i) => nullable(i)),
	city: Factory.each(() => chance.city()),
	street: Factory.each(() => chance.street()),
	zipCode: Factory.each(() => chance.zip()),
	country: Factory.each(() => countryFactory.build()),
});
